<script>
export let genres = [];
let leftIndex = 0;
let rightIndex = 1;
let selection = '';
$: faceoff = [genres[leftIndex], genres[rightIndex]]

function handleClick(...args) {
	const index = Number(this.getAttribute('data-index'))
	if (index === 0) {
		rightIndex = rightIndex + 1;
		if (rightIndex <= leftIndex) {
			rightIndex = leftIndex + 1;
		}
	} else {
		leftIndex = leftIndex + 1;
		if (leftIndex <= rightIndex) {
			leftIndex = rightIndex + 1;
		}
	}

	if (!genres[leftIndex] || !genres[rightIndex]) {
		selection = (!genres[leftIndex]) ? genres[rightIndex] : genres[leftIndex]
	}
}
</script>

<main>
	<h1>What should I eat?</h1>

	{#if selection}
		<h2>You should get {selection}</h2>
	{/if}

	{#if !selection}
		<div class="choices">
			{#each faceoff as genre, i}
				<button class="choice" data-index={i} on:click={handleClick}>
					<h1>
						{genre}
					</h1>
				</button>
			{/each}
		</div>
	{/if}
</main>

<style>
.choices {
	display: flex;
	align-items: center;
	justify-content: center;
}
.choice {
	display: flex;
	width: 200px;
	height: 200px;
	border: solid 1px #000;
	align-items: center;
	justify-content: center;
}
.choice:first-child {
	margin-right: 2em;
}
</style>